module.exports = __webpack_public_path__ + "img/7607a34490e66921b0b7db8ac46f1d9c.097a76b4.png";